let urls = null

const load = async (language, hostName) => {
  urls = await import(`./urls/${language}`)
  Object.keys(urls).forEach(key => {
    urls[`${key}WithHost`] = `${hostName}${urls[key]}`
  })
}

export { urls as default, load }